<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <p class="head">Part C</p>
      <div class="sub-header d-flex align-center justify-space-between">
        <p>Fill Your Witnesses Details- You have to add details of two witnesses
</p>
        <!-- <p class="content pending">Pending</p> -->
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-app id="sub-accordian">
        <v-expansion-panels>
          <v-expansion-panel class="deposits-section" v-for="(witnes,index) in witneses" :key="index">
            <v-expansion-panel-header
              ><p class="sub-title">Witness {{witnes.witness}}</p>
              <div class="amount-box">
                <v-col class="memberbox-editbox">
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        fab
                        color="#F19700"
                        v-bind="attrs"
                        v-on="on"
                        @click="showHide"
                      >
                        <v-img
                          max-height="20"
                          max-width="20"
                          :src="three_dots"
                          :lazy-src="three_dots"
                        ></v-img>
                      </v-btn>
                    </template>
                    <v-list v-if="hideShow">
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="save_witness(witnes)">
                            <v-img
                              max-height="23"
                              max-width="19"
                              :src="update_pic"
                              :lazy-src="update_pic"
                              
                            >
                            </v-img
                            >Save
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="hr-line"></div>
              <div class="deposits-content">
                <v-row class="deposits-second-content">
                  <v-col md="2" sm="6" cols="12">
                    <p>TITLE</p>
                    <div class="input-field-box">
                      <v-select
                        v-model="witnes.title"
                        :rules="textRule"
                        :items="title_list"
                        item-value="name"
                        item-text="name"
                        outlined
                        dense
                        placeholder="Title"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col md="5" sm="6" cols="12">
                    <p>NAME</p>
                    <div class="input-field-box">
                      <v-text-field
                        type="text"
                        v-model="witnes.name"
                        :rules="textRule"
                        outlined
                        dense
                        placeholder="Mrs. XXX"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col md="5" sm="6" cols="12">
                    <p>GENDER</p>
                    <div class="input-field-box">
                      <v-select
                        v-model="witnes.gender"
                        :rules="textRule"
                        :items="gender_list"
                        item-value="name"
                        item-text="name"
                        outlined
                        dense
                        placeholder="Select Gender"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col md="4" sm="6" cols="12">
                    <p>CONTACT NUMBER</p>
                    <div class="input-field-box">
                      <v-text-field
                        type="text"
                        v-model="witnes.contact_no"
                        :rules="numberRule"
                        maxlength="10"
                        outlined
                        dense
                        placeholder="Enter Number.."
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col md="4" sm="6" cols="12">
                    <p>RELATION</p>
                      <v-select  
                        v-model="witnes.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        :rules="textRule"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                  </v-col>
                  <v-col md="4" sm="6" cols="12">
                    <p>OCCUPATION</p>
                    <div class="input-field-box">
                      <v-select
                            :items="occupation_list"
                            item-value="name"
                            item-text="name"
                            placeholder="Choose Occupation"
                            v-model="witnes.occupation"
                            solo
                          ></v-select>
                    </div>
                  </v-col>
                  <v-col md="4" sm="6" cols="12">
                    <p>STATE</p>
                    <div class="input-field-box">
                      <v-select
                        v-model="witnes.state"
                        :rules="textRule"
                        :items="stateList"
                        item-value="state_name"
                        item-text="state_name"
                        @change="getCityData($event,index)"
                        outlined
                        dense
                        placeholder="Select State"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col md="4" sm="6" cols="12">
                    <p>CITY</p>
                    <div class="input-field-box">
                      <v-select
                        :items="witnes.cityList"
                        v-model="witnes.city"
                        item-value="city_name"
                        item-text="city_name"
                        :rules="textRule"
                        outlined
                        dense
                        placeholder="Select City"
                      ></v-select>
                    </div>
                  </v-col>
                  
                  <v-col md="4" sm="6" cols="12">
                    <p>PIN</p>
                    <div class="input-field-box">
                      <v-text-field
                        v-model="witnes.pin"
                        :rules="numberRule"
                        maxlength="6"
                        minlength="6"
                        outlined
                        dense
                        placeholder="XXXXXX"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>ADDRESS</p>
                    <div class="input-field-box">
                      <v-textarea
                        rows="3"
                        v-model="witnes.address"
                        :rules="textRule"
                        outlined
                        dense
                        placeholder="Enter Address"
                      ></v-textarea>
                    </div>
                  </v-col>
                </v-row>
              </div>
               <div class="button-group">
                <button class="btn cancle-btn">CANCEL</button>
                <button class="btn save-btn" @click="save_witness(witnes)">SAVE</button>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-app>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import axios from 'axios';
export default {
    props: ['member_id','will_id','relation_list'],
    data: (instance) => ({
      three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
      edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
      delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
      update_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'update.png',
      witneses:[{ address:'', city:'', contact_no:'',title:'', name:'', occupation:'',gender:'', pin:'', relation:'', state:'', witness:1 }, { address:'', city:'', contact_no:'',title:'', name:'', occupation:'',gender:'', pin:'', relation:'', state:'', witness:2 }],
      occupation_list:[{name:'Service'}, {name:'Business'}, {name:'Professional'}, {name:'Retired'}, {name:'Student'}, {name:'Agricultural Activities'}, {name:'Self Employed'}],
      hideShow:false,
      hideShowId:'',
      title_list:[{name:'Mr'}, {name:'Mrs'}, {name:'Jr'}, {name:'Sr'}, {name:'Prof'}, {name:'Dr'}, {name:'Esq'},{name:'Rev'}, {name:'St'}, {name:'Hon'}],

      relation_list:instance.relation_list,
      gender_list:[{name:'Male'},{name:'Female'},{name:'Transgender'}],
      relation:"",
      stateList:[],
      occupation:'',
      gender:'',
      cityList:[],
      items: [],
      numberRule: [
       v => !!v || 'Field is required',
       v => /^\d+$/.test(v) || 'Must be a number',
      ],
      textRule:[
        v => !!v || 'Field is required',
      ],
    }),
    mounted(){
      this.getStateData()
    },
    methods:{
        showHide(){
        this.hideShow =true;
        },
        save_witness(formdata){
          formdata.aws_cognito_id = atob(localStorage.getItem('cognito_idp'));
          formdata.will_id = this.will_id;
          axios.post(process.env.VUE_APP_ROOT_API + "save-witness-details", formdata, {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          })
          .then((response) => {
            if(response.data.status == 'success'){
              swal.fire({
                title:'Success!',
                text:response.data.message,
                icon:'success'
              })
            }
            else {
              swal.fire({
                title:'Error!',
                text:response.data.error,
                icon:'error'
              })
            }
          })
        },
        getWitnessDetails(will_id){
            let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
            var formdata = new FormData()
            formdata.append("aws_cognito_id", cognito_idp);
            formdata.append("will_id", will_id);
            axios.post(process.env.VUE_APP_ROOT_API + "get-witness-details", formdata, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
            })
            .then((response) => {
              this.witneses = response.data.witness_details;
              this.witneses.forEach((item, index)=>{
                  let state_name = item.state;
                  this.getCityData(state_name,index)
              })
              let arrLength = response.data.witness_details.length;
              let remainingWitnesses = 2 - response.data.witness_details.length;
              for(var i = 0; i < remainingWitnesses; i++){
                this.witneses.push({
                  address:'',
                  city:'',
                  contact_no:'',
                  name:'',
                  title:'',
                  occupation:'',
                  gender:'',
                  pin:'',
                  relation:'',
                  state:'',
                  witness:i+arrLength+1,
                })
              }
            })
        },
        deleteWitness(type)
        {
            let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
            var formdata = new FormData()
            formdata.append("aws_cognito_id", cognito_idp);
            formdata.append("main_member_id", this.member_id);
            if(type == 'one')
            {
              axios.post(process.env.VUE_APP_ROOT_API + "delete-witness-details1", formdata, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
              },
              }).then((response) => {
                swal.fire({
                title:'Witness1 Deleted Successfully',
                icon:'success'
              })
              });
            }
            else if(type == 'two')
            {
              axios.post(process.env.VUE_APP_ROOT_API + "delete-witness-details2", formdata, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
              },
              }).then((response) => {
                swal.fire({
                title:'Witness2 Deleted Successfully',
                icon:'success'
              })
              });
            }
        },
        getStateData()
        {
           let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
            var formdata = new FormData()
            formdata.append("aws_cognito_id", cognito_idp);
            axios.post(process.env.VUE_APP_ROOT_API + "get-state-list", formdata, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
            })
            .then((response) => {
              this.stateList = response.data.state_list;

            });  
        },
        getCityData(state_name,index){
           let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
            var formdata = new FormData()
            formdata.append("aws_cognito_id", cognito_idp);
            formdata.append("state_name", state_name);
            axios.post(process.env.VUE_APP_ROOT_API + "get-city-list", formdata, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
            })
            .then((response) => {
              this.$set(this.witneses[index], 'cityList', response.data.city_list);
            });
        }
    }
    
};
</script>

<style>
</style>